import { Star } from "lucide-react";

const testimonials = [
  {
    name: "Martin K.",
    vehicle: "BMW M3",
    quote:
      "PPF Garage pani tähelepanu detailidele ja tulemus oli lihtsalt tipptasemel. Auto näeb välja nagu just poest ostetud.",
    rating: 5,
  },
  {
    name: "Kati L.",
    vehicle: "Audi Q5",
    quote:
      "Keraamiline kaitse ja hooldus olid täpselt sellised, mida ootasime. Pinnad on puhtad ja läikivad juba nädalaid.",
    rating: 5,
  },
  {
    name: "Rene P.",
    vehicle: "Porsche 911",
    quote:
      "Professionaalne meeskond, selge kommunikatsioon ja suurepärane kvaliteet. Soovitan kindlasti edasi.",
    rating: 5,
  },
];

// TODO: replace demo testimonials with real reviews after collecting them through Google Business Profile or post-sale SMS flow.
export default function TestimonialsSection() {
  return (
    <section className="py-24 px-6 bg-secondary">
      <div className="mx-auto max-w-7xl">
        <div className="mb-12 max-w-3xl">
          <p className="mb-3 text-[12px] uppercase tracking-[0.2em] text-accent">Kliendi kogemused</p>
          <h2 className="font-heading text-3xl font-bold text-text-main sm:text-4xl">
            Miks kliendid usaldavad meid
          </h2>
          <p className="mt-4 text-base leading-relaxed text-text-muted">
            Meie teenused on loodud kvaliteedi, täpsuse ja pikaajalise kaitse nimel. Vaadake, kuidas kliendid meie tööd hindavad.
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-3">
          {testimonials.map((item) => (
            <article key={item.name} className="rounded-sm border border-white/10 bg-primary/80 p-8">
              <div className="mb-5 flex gap-1 text-accent">
                {Array.from({ length: item.rating }).map((_, starIndex) => (
                  <Star key={starIndex} className="h-4 w-4 fill-current" />
                ))}
              </div>
              <p className="mb-6 text-sm leading-relaxed text-text-muted">“{item.quote}”</p>
              <div>
                <p className="font-heading font-semibold text-text-main">{item.name}</p>
                <p className="text-sm text-text-muted">{item.vehicle}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
